import { DatabaseProvider } from '../database/database';
import { AppState } from '../../config/state';
import { Injectable, ApplicationRef } from '@angular/core';
import { Collection } from 'lokijs';
import moment from 'moment';
import { PatronProvider, PatronDetails, PatronCheckout } from '../patron/patron';
import { Events, ModalController, LoadingController, MenuController } from 'ionic-angular';
import { CoLoginComponent } from '../../components/co-login/co-login';
import { ToastAlertsProvider } from '../toast-alerts/toast-alerts';
import { ListProvider } from '../list/list';
import { CoNovelistModalPage } from '../../pages/co-novelist-modal/co-novelist-modal';
import { TimeoutProvider } from '../timeout/timeout';
import { CoLogoutSurveyPage } from '../../pages/co-logout-survey/co-logout-survey';
import { PrintingProvider } from '../printing/printing';
/*
  Generated class for the LoginProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoginProvider {
  private patronCollection: Collection;
  private novelistModal: any = false;
  private surveyModal: any = false;
  constructor(
    private db: DatabaseProvider,
    private state: AppState,
    private patron: PatronProvider,
    private events: Events,
    private modalCtrl: ModalController,
    private loader: LoadingController,
    private toast: ToastAlertsProvider,
    private menuCtrl: MenuController,
    private listProvider: ListProvider,
    private timeout: TimeoutProvider,
    private printing: PrintingProvider,
    private ref: ApplicationRef
  ) {
    this.events.subscribe('timeoutCalled', () => {
      if (this.state.loggedInPatronId) this.logout(null, true);
    });
  }

  public async requireLogin(success, cssClass?, pinless?, navigate=true, prefill?) {
	if(this.state.staff){
		// this.state.loggedInPatronId = null;
    // this.state.patron = false; //TODO: FIGURE OUT WHY THIS SHIT BREAKS EVERYTHING
    // console.log(this.state.patron, this.state.loggedInPatronId);
	}
    const patron = await this.getCurrent();
    // console.log(patron);
    if (patron) {
      success(patron);
      return patron;
    } else {
      if (this.state.staff) {
        pinless = true;
      }
      await this.presentLogin(success, cssClass, pinless, navigate, prefill);
    }
  }

  private async presentLogin(success, cssClass?, pinless?, navigate?, prefill?) {
    if (!cssClass) {
      cssClass = '';
    }
    if(this.state.staff)  {
      this.state.refreshPatron = true;
    }
    let modal = this.modalCtrl.create(CoLoginComponent, { pinless: pinless, login: (barcode, pin) => this.login(barcode, pin), prefillScan: prefill }, { cssClass: `loginModalBase ${cssClass}`, enableBackdropDismiss: false });
    modal.present();
    let timedOut = false;
    this.events.subscribe('timeoutCalled', () => (timedOut = true)); //if login presented and timed out don't nav pop more than needed
    modal.onWillDismiss(res => {
      if (!res && navigate) {
        if (!this.menuCtrl.isOpen() && !timedOut) {
          if (this.state.nav.length() > 1) this.state.nav.pop().catch(err =>{});
        }
      }
    });
    await modal.onDidDismiss(res => {
      if (res === undefined) {
        // console.log(this.views, this.state.nav.length());
        if (!this.menuCtrl.isOpen() && !timedOut) {
          // this.state.nav.pop();
        }
        return null;
      }
      this.events.unsubscribe('timeoutCalled', () => (timedOut = true));

      // if (!this.state.preventLogin) this.state.loggedInPatronId = res.id;
      // this.state.patron = res;
      this.login(res.barcode, res.pin);
      success(res);
      return res;
    });
  }

  public async newLoginUser(success) {
    await this.presentLogin(success).then(res => {
      return res;
    });
  }

  public async login(barcode: string, pin?: string): Promise<PatronDetails> {
    if (this.state.patron && this.state.patron.barcode === barcode && !this.state.preventLogin && !this.state.refreshPatron) {
      this.events.publish('patronLoggedIn', true);
      this.events.publish('switchedUser', this.state.patron);
      this.state.checkingForAnotherPatron = false;
      return this.state.patron;
    }
    return this.patron.getSummaryDetails(barcode, pin).then(async details => {
		try{
			//lookup the patron on the ils
			if (details && details.id) {
				this.state.patron = null;
				details.lastUpdate = moment().toISOString(); //set the last updated time to now
        details.pin = pin; //TODO: we should encrypt or tokenize this
        // SAVING ACCOUNTS TO THE RECENT ARRAY
        if (this.state.staff || this.state.preventLogin){
          let duplicate = this.state.recentAccounts.find(ac => ac.id === details.id);
          if (!duplicate){
            if (this.state.recentAccounts.length >= 15) {
              this.state.recentAccounts.pop();
              this.state.recentAccounts.unshift(details);
            } else {
              this.state.recentAccounts.unshift(details);
            }
          }
          this.state.patron = details;
          this.events.publish('patronLoggedIn', true);
          return details;
        }
				if (!this.state.patron) {
				this.state.patron = details;
				this.state.patron.changedItems = [];
				}
        this.state.refreshPatron = false;
				this.state.checkingForAnotherPatron = false;
				// console.log(this.state)
				if (!this.state.preventLogin && !this.state.staff) {
				// this.listProvider.addToList('allUsers', details).then((res) => {
				// });
				this.state.loggedInPatronId = details.id; //set this as out logged in patron
        if (this.patronCollection.find({"id":details.id}).length <= 0){
          console.log('not a duplicated');
          try {
            this.patronCollection.insertOne(details); //add this patrons details to the patron database
          } catch(err) {
            console.log(err);
          }
          await this.db.saveDB(); //save the database now we have made changes
        }
				// if(!this.state.staff){
					// try {
					// 	this.patronCollection.insertOne(details);
					// } catch (err) {
					// 	console.log(err);
					// }
				// }
				this.events.publish('patronLoggedIn', true);
				this.events.publish('switchedUser', details);
        }

        return details;
				// console.log(this.patronCollection, this.db.getCollection('patrons'));
			}
		}catch(err){
			console.error(err);
			return null;
		}
    });
  }
  // async getAllUsers(): Promise<any> {
  //   let users = [
  //     {
  //       name: "User 1",
  //       img: ""
  //     },
  //     {
  //       name: "User 2",
  //       img: ""
  //     },
  //     {
  //       name: "User 3",
  //       img: ""
  //     }
  //   ]
  //   return users;
  // }
  public async definePatronCollection(): Promise<boolean> {
    this.patronCollection = this.db.getCollection('patrons');
    return true;
  }
  public async getCurrent(): Promise<PatronDetails> {
    let patron = await this.patronCollection.findOne({ id: this.state.loggedInPatronId });
    //TODO: check how hold this data is with lastUpdate and load it again if its out of date

    return patron || null;
  }
  public async getPatronCollection(): Promise<any> {
    if (!this.patronCollection) {
      this.definePatronCollection().then(() => {
        return this.patronCollection.find();
      });
    } else {
      return this.patronCollection.find();
    }
  }
  private async updateCheckouts(patron: PatronDetails): Promise<Array<PatronCheckout>> {
    patron.checkouts = await this.patron.getCheckouts(patron.barcode, patron.pin);
    return patron.checkouts;
  }
  public async updateCurrentCheckouts() {
    return this.updateCheckouts(await this.getCurrent());
  }
  public async logout(timer?: number, timeout?: boolean): Promise<Boolean> {
    let customMsg;
    this.promptForReceipt(timeout || false).then(async out => {
      // if (out) return true;
      this.state.logoutSummary && this.state.logoutSummary.length > 0 ? (customMsg = this.state.logoutSummary) : (customMsg = '');
      this.state.checkingForAnotherPatron = true;
      // console.log(this.state.checkingForAnotherPatron);
      this.patronCollection
        .chain()
        .find({ id: this.state.loggedInPatronId })
        .remove();
      await this.db.saveDB();
      this.state.loggedInPatronId = null;
      this.state.patron = null;
      this.events.publish('patronLoggedIn');
      if (this.state.sharedScreen) {
        this.db.resetDB();
      }

      this.showNovelistScreen() //First step, if novelist enabled and recommendeds exist
        .then(noMsg => this.createLogoutSurvey(noMsg)) //Second step, if survey enabled
        .then(m => {
          //Last, show logout alert depending on staff/patron
          if (this.state.timeoutEnabled) this.timeout.resetTimeout();
          this.state.preventLogin = false;
          if (this.state.patron) this.state.patron = null;
          if (this.state.novelistArray) this.state.novelistArray = [];
          // console.log(this.state);
          setTimeout(() => this.ref.tick(), 0);
          if (m === 'bypass' || out) {
            this.state.checkingForAnotherPatron = false;
            // console.log('logged out');
            if (this.state.staff) {
              this.state.nav.popToRoot();
            }
          } else {
            if (!this.state.staff) {
              // console.trace();
              this.toast.showAlert('', 'You have been logged out!' + customMsg, 'success', timer || 2000).then(() => {
                this.state.logoutSummary = '';
                //CHECKING TO SEE IF ANY OTHER LOGGED IN USERS ON PHONE
                if (!this.state.sharedScreen){
                  this.getPatronCollection().then(list => {
                    if (list.length > 0) {
                      this.login(list[0].barcode, list[0].pin);
                    } else {
                      this.events.publish('patronLoggedIn');
                      this.state.checkingForAnotherPatron = false;
                    }
                  });
                }
              });
            } else {
              this.state.nav.popToRoot();
              this.toast.showAlert('', 'Successfully signed out!', 'success', timer || 2000);
              this.state.checkingForAnotherPatron = false;
            }
          }
        });
    });
    // console.log(this.patronCollection, this.db.getCollection('patrons'));
    return true;
    // // console.log(this.state.patron);
  }
  public instantLogout(timer?: number) {
    this.logout(timer || 2000).then(done => {
      if (done) {
        console.log('using instant logout');
        this.state.nav.popToRoot();
      }
    });
  }
  private showNovelistScreen(): Promise<any> {
    this.state.preventLogin = true;
    return new Promise((res, rej) => {
      if (!this.state.showNovelistOnLogout || !this.state.novelistArray || this.state.novelistArray.length <= 0) return res(true);

      let modal = this.modalCtrl.create(CoNovelistModalPage, {}, { cssClass: 'custom-wide-modal' });
      modal.present().catch(err => res(true));

      modal.onDidDismiss(() => {
        res('bypass');
      });
    });
  }
  private createLogoutSurvey(noMsg): Promise<any> {
    return new Promise((res, rej) => {
      if (!this.state.surveyEnabled) return res(noMsg);

      let modal = this.modalCtrl.create(CoLogoutSurveyPage, {}, { cssClass: 'full-screen-survey' });
      modal.present();

      modal.onDidDismiss(() => {
        res(noMsg);
      });
    });
  }
  private promptForReceipt(timedOut): Promise<any> {
    return new Promise((res, rej) => {
		try{
			if (!this.state.sharedScreen) return res(false); //ignore this if not share screen
			if (this.state.ignorePromptForReceipt) return res(false);
			if (timedOut) return res(false); //if called because of timeout
			if (this.state.patron && this.state.patron.changedItems.length <= 0) return res(false); //ignore if patron didn't do anything
			let arr = this.state.patron.changedItems.reduce((count, itm) => {
				if (count.indexOf(itm.type) == -1) count.push(itm.type);
				return count;
			}, []); //check if done 2 unique things
			// console.log(arr, arr.length);
			if (arr.length < 2 && arr[0] !== 'cancelHold' && arr[0] !== 'return' && arr[0] !== 'failedrenew') return res(false); //ignore if less than 2 done or if they aren't cancel hold/return digital
			this.toast.showGenericConfirm('You are about to log out, would you like a receipt of your updates?').then(decision => {
				if (decision == 1) {
				this.printing.printUpdatedItemsReceipt(this.state.patron.changedItems).then(() => {
					return res(false);
				});
				} else if (decision == 0) {
				return res(false);
				} else {
				return res(true);
				}
			});
		}catch(err){
			console.error(err);
			return res(false);
		}
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/login/login.ts